// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3c7Na","content":"Consent_content__1mRZW","footer":"Consent_footer__l_96D"};